module.exports = __webpack_public_path__ + "b23a7a2294dc724f21124fddd41efa5c.svg";